export default function getCardMaxWidth(
  cols: number,
  spacer = 24,
  wrapperWidth = 1224
) {
  return wrapperWidth / cols - spacer;
}
